import React from 'react';
import {Icons} from '@/constants';
import {cn} from '@/utils/common_functions';

export type IconType = keyof typeof Icons;

interface IconProps {
  type: IconType;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = props => {
  const {type, className = '', style = {}} = props;
  const iconSource: any = Icons[type];
  return (
    <img
      alt={`${type}-icon`}
      src={iconSource}
      className={cn([`size-[20px] object-contain`, className])}
      style={style}
    />
  );
};
